/*
 *
 * GiftCardCart actions
 *
 */
import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { rootApiResponse, clearDefaultError, getUpdatedUserProfile, resetPopup, GET_REQ_HANDLER } from '../HeaderContainer/actions';
import { utils, constants, eventTracking } from '../../devUtils';
import {
  DEFAULT_ACTION,
  FETCH_CARTLIST_SUCCESS,
  DELETE_CART_ITEM_SUCCESS,
  // ADDTOCART_SUCCESS,
  FETCH_USER_ADDRESS,
  CHECK_ADDTOCART_ACTION_TYPE,
} from './constants';
import { FETCH_BILLING_ADDRESS } from '../_DeliveryAdd/constants';
// import { ADDTOCART_SUCCESS } from '../GiftCardsList/constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

const successActionData = (payload) => ({ type: FETCH_CARTLIST_SUCCESS, payload });
const removeCartItemSuccess = (payload) => ({ type: DELETE_CART_ITEM_SUCCESS, payload });
// const addToCartSuccess = (payload) => ({ type: ADDTOCART_SUCCESS, payload });
const fetchAddressSuccess = (payload) => ({ type: FETCH_USER_ADDRESS, payload });

/**
 * @todo no need of @func dispatch(utils.isReducerLoading(DEFAULT_ACTION)); as it is been handled @func dispatch(successActionData(cart_obj));
 */
export const fetchCartItemList = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const url = `${endpoint.GET_CART_LIST}/${payload}`;
    // const _api = utils.addAuthHeaders(getState, api);
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const cart_obj = await reqHandler.getHandler(api, url, null, authPrerequist);
    // utils.removeAuthHeaders(_api);
    dispatch(successActionData(cart_obj));
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

export const deleteCartItem = (payload, actionType = null, clientid = null, req_payload, req_action, history, trackingObj) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    // const _api = utils.addAuthHeaders(getState, api);
    const url2 = `${endpoint.GET_CART_LIST}/${payload.cartId}/items`;
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    for (let i = 0; i < payload.items.length; i++) {
      const response = await deleteItemFromList(api, url2, payload.items[i], authPrerequist);
    }
    dispatch(removeCartItemSuccess(true));
    dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ALERT_CART_ITEM_REMOVED_SUCCESS)));
    if (actionType === 'empty') {
      const url3 = `${endpoint.GET_CART_LIST}/${payload.cartId}`;
      const requestObj = { skip_payable_validation: true, order: { zaggle_card_client_id: clientid } };
      await triggerUpdateOrder(authPrerequist, api, url3, requestObj);
      dispatch(addToCartAction(req_payload, payload.cartId, req_action, history, trackingObj));
    }
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(fetchCartItemList(payload.cartId));
    dispatch(getUpdatedUserProfile());
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

export const updateOrder = (payload, orderId, history) => async (dispatch, getState, api) => {
  try {
    const url = `${endpoint.GET_CART_LIST}/${orderId}`;
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await triggerUpdateOrder(authPrerequist, api, url, payload);
    if (response && response.id) {
      utils.forceRedirect(history, { pathname: constants.LINK_ORDER_SUMMARY, state: { isClicked: true } });
    } else {
      dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response)));
    }
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

async function triggerUpdateOrder(authPrerequist, api, url3, requestObj) {
  // const _api = utils.addAuthHeaders(getState, api);
  // const authPrerequist = utils.getAuthPrerequist(getState, true);
  const response = await reqHandler.putHandler(api, url3, requestObj, authPrerequist);
  return response;
}

async function deleteItemFromList(api, url, payload, authPrerequist) {
  const responseObj = await reqHandler.deleteHandler(api, url, payload, authPrerequist);
  return responseObj;
}

// const fetchUserDetails = (dispatch, getState) => {
//   const userDetails = utils.immutableToJS(utils.immutableUserDetails(getState));
//   const { device_id, token } = userDetails;
//   dispatch(fetchUserProfile({ token, device_id }));
// };

export const addToCartAction = (payload, product_id, actionType, history, { productName: name, isThisRedeempage, apiMethod = 'POST' }) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    // dispatch(clearDefaultError());
    let history_data = history;
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    if (actionType === 'updateClient' || actionType === 'updateClient&buyNow') {
      // this case will come whenever the cart is empty and if you want to update the clientid in order
      // In this case history constructor will comes as object contains { clientId, cartId, history }
      const url3 = `${endpoint.GET_CART_LIST}/${product_id}`;
      const requestObj = { skip_payable_validation: true, order: { zaggle_card_client_id: history.clientId } };
      await triggerUpdateOrder(authPrerequist, api, url3, requestObj);
      dispatch(fetchCartItemList(history.cartId));
      history_data = history.history;
    }
    const url = `${endpoint.GET_CART_LIST}/${product_id}/items`;
    // const _api = utils.addAuthHeaders(getState, api);
    const response = await GET_REQ_HANDLER(apiMethod)(api, url, payload, authPrerequist);
    // utils.removeAuthHeaders(_api);
    if (response.message) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(resetPopup(response.message, 'error'));
      const { location: { pathname = '' } } = history;
      eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${name}>---<Failure>`);
    } else {
      const action_type = actionType === 'updateClient&buyNow' ? 'buyNow' : actionType;
      dispatch(triggerSuccess(action_type, history_data, name, isThisRedeempage));
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    const { location: { pathname = '' } } = history;
    eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${name}>---<Failure>`);
    dispatch(resetPopup(err, 'error'));
  }
};

const triggerSuccess = (actionType = null, history, productName = null, isThisRedeempage = false) => (dispatch) => {
  const { location: { pathname = '' } } = history;
  dispatch(utils.isReducerLoading(DEFAULT_ACTION));
  dispatch(getUpdatedUserProfile());
  dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ALERT_CART_ITEM_ADDED_SUCCESS)));
  eventTracking.triggerEvent('Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${productName}>---<Success>`);
  // IF ACTION TYPE IS EQUAL TO 'buyNow' NEED TO REDIRECT CART PAGE
  if (actionType && actionType === 'buyNow') {
    utils.forceRedirect(history, { pathname: constants.GIFT_CARD_CART });
    eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname, actionType), `<${productName}>---<Success>`);
  } else {
    eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${productName}>---<Success>`);
  }
};

export const createCart = (payload, { actionType = null, history = {}, productName = null, isThisRedeempage = false }) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const url = `${endpoint.GET_CART_LIST}`;
    // const _api = utils.addAuthHeaders(getState, api);
    const authPrerequist = utils.getAuthPrerequist(getState, true, true);
    const response = await reqHandler.postHandler(api, url, payload, authPrerequist);
    // utils.removeAuthHeaders(_api);
    const { location: { pathname = '' } } = history;
    if (response.message) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response.message)));
      eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${productName}>---<Failure>`);
    } else {
      dispatch(fetchCartItemList(response.id));
      dispatch(triggerSuccess(actionType, history, productName, isThisRedeempage));
      // eventTracking.triggerEvent('Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${name}>---<Success>`);
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
    const { location: { pathname = '' } } = history;
    eventTracking.triggerEvent(isThisRedeempage ? 'Redeem ZSC' : 'Gift Cards', CHECK_ADDTOCART_ACTION_TYPE(pathname), `<${productName}>---<Failure>`);
  }
};

/**
 * @todo check dependency or remove @func userAddress @deprecated
 */
export const fetchUserAddress = (payload, actionType) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    // const _api = utils.addAuthHeaders(getState, api);
    let response = {};
    if (actionType === 'get') {
      response = await reqHandler.getHandler(api, endpoint.GET_USER_ADDRESS, payload, authPrerequist);
      dispatch(fetchAddressSuccess(response));
    } else if (actionType === 'post') {
      const _authPrerequist = utils.getAuthPrerequist(getState, true, true);
      response = await reqHandler.postHandler(api, endpoint.GET_USER_ADDRESS, payload, _authPrerequist);
      if (!response.messasge) {
        dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ADDRESS_UPDATE_SUCCESS)));
        dispatch(fetchUserAddress(FETCH_BILLING_ADDRESS, 'get'));
        // fetchUserDetails(dispatch, getState);
      } else {
        throw (response.messasge);
        // dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response.messasge)));
      }
    } else if (actionType === 'delete') {
      const url = `${endpoint.GET_USER_ADDRESS}/${payload}`;
      response = await reqHandler.deleteHandler(api, url, null, authPrerequist);
      if (response.message) {
        throw (response.message);
        // dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response.messasge)));
      } else {
        dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ADDRESS_DELETE_SUCCESS)));
        dispatch(fetchUserAddress(FETCH_BILLING_ADDRESS, 'get'));
        // fetchUserDetails(dispatch, getState);
      }
    } else if (actionType === 'put') {
      const url = `${endpoint.GET_USER_ADDRESS}/${payload.id}`;
      response = await reqHandler.putHandler(api, url, payload.payload, authPrerequist);
      if (response.message) {
        throw (response.message);
        // dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, response.messasge)));
      } else {
        dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, constants.ADDRESS_DELETE_SUCCESS)));
        dispatch(fetchUserAddress(FETCH_BILLING_ADDRESS, 'get'));
        // fetchUserDetails(dispatch, getState);
      }
    }
    // utils.removeAuthHeaders(_api);
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};

export const updateCartItemValues = (payload, cartId) => async (dispatch, getState, api) => {
  try {
    dispatch(clearDefaultError());
    const url = `${endpoint.GET_CART_LIST}/${cartId}/items`;
    // const _api = utils.addAuthHeaders(getState, api);
    const authPrerequist = utils.getAuthPrerequist(getState, true);
    const response = await reqHandler.putHandler(api, url, payload, authPrerequist);
    // utils.removeAuthHeaders(_api);
    if (response.message) {
      throw (response.message);
    } else {
      dispatch(fetchCartItemList(cartId));
    }
  } catch (err) {
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
  }
};




// WEBPACK FOOTER //
// client/containers/GiftCardCart/actions.js